export default {
  overLimit: 'Over the max download limit',
  orderNo: 'Order No'
}
